import { Plus, ArrowDown } from "lucide-react";
import { APP_BLOCKS } from "../data/content";
import { Reveal } from "../components/Reveal";
import PhoneMockup from "../components/PhoneMockup";
import { scrollToTarget } from "../lib/scroll";

const AppFeatures = () => (
  <section id="app" data-testid="rnb-app-features-section" className="py-20 lg:py-32 bg-zinc-100 border-y border-zinc-200 overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center mb-16 lg:mb-24">
        <span className="inline-block bg-black text-white text-[10px] font-bold tracking-[0.35em] px-4 py-2 uppercase">
          App RNB · Próximamente
        </span>
      </Reveal>
      <div className="space-y-24 lg:space-y-32">
        {APP_BLOCKS.map((block, i) => (
          <div
            key={block.title}
            data-testid={`rnb-app-feature-block-${i + 1}`}
            className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}
          >
            <Reveal>
              <PhoneMockup caption={block.title} tilt={i % 2 === 0 ? "left" : "right"} />
            </Reveal>
            <Reveal delay={0.15}>
              <p className="text-xs tracking-[0.4em] text-zinc-500 uppercase">0{i + 1} · App RNB</p>
              <h3 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl text-black leading-[0.95]">{block.title}</h3>
              <p className="mt-5 text-base text-zinc-600 font-light leading-relaxed max-w-lg">{block.text}</p>
              <ul className="mt-8 space-y-5">
                {block.points.map((pt) => (
                  <li key={pt.head} className="flex gap-4">
                    <Plus className="h-5 w-5 mt-0.5 shrink-0 text-black" />
                    <div>
                      <p className="text-sm font-semibold tracking-wide text-black">{pt.head}</p>
                      <p className="mt-1 text-sm text-zinc-600 leading-relaxed">{pt.body}</p>
                    </div>
                  </li>
                ))}
              </ul>
              {block.labels && (
                <div className="mt-8 flex flex-wrap gap-2">
                  {block.labels.map((l) => (
                    <span key={l} className="border border-zinc-400 text-zinc-700 text-[10px] tracking-[0.2em] uppercase px-3 py-1.5">
                      {l}
                    </span>
                  ))}
                </div>
              )}
            </Reveal>
          </div>
        ))}
      </div>
      <Reveal delay={0.2} className="mt-16 text-center">
        <button
          onClick={() => scrollToTarget("#contacto")}
          data-testid="rnb-app-cta-notify"
          className="group inline-flex items-center gap-3 border border-black text-black font-display text-xl tracking-[0.15em] px-8 py-4 hover:bg-black hover:text-white transition-colors"
        >
          QUIERO LA APP: AVÍSAME CUANDO ESTÉ LISTA
          <ArrowDown className="h-5 w-5 transition-transform duration-300 group-hover:translate-y-1" />
        </button>
      </Reveal>
    </div>
  </section>
);

export default AppFeatures;
